// 自動生成されたEnum登録ファイル
// このファイルは自動生成されます。手動で編集しないでください。

import EnumManager from "../../utils/enumManager";

// 利用可能なenum型をインポート
import {
  ComparisonOperator,
  ContactType,
  CurrencyType,
  DataEnvironment,
  ExpireType,
  FollowRequestActionType,
  GiftDistributionType,
  GiftState,
  ItemReasonType,
  ItemType,
  LobbySlotState,
  LobbyState,
  LobbyStreamAction,
  LobbyStreamEvent,
  LobbyStreamResultType,
  LogicOperator,
  MaintenanceType,
  MatchType,
  MissionTaskType,
  MissionType,
  NotificationStreamAction,
  NotificationStreamEvent,
  NotificationType,
  OSType,
  OrnamentType,
  PlatformType,
  PurchaseLimitScopeType,
  ShogiPieceRarityType,
  SubscriptionIntervalType,
  SubscriptionType,
  UserFollowState,
  UserMigrateBitType,
} from "../../proto/generated/consts/constant_pb";

/**
 * 全てのenum型を自動登録
 * ラベルフォーマッターはenumDocumentationDataからcommentを取得して自動的に日本語名を表示
 */
export function registerAllEnums(): void {
  // ComparisonOperator を登録
  EnumManager.registerEnum(
    "ComparisonOperator",
    ComparisonOperator as unknown as Record<string, number>,
  );
  // ContactType を登録
  EnumManager.registerEnum(
    "ContactType",
    ContactType as unknown as Record<string, number>,
  );
  // CurrencyType を登録
  EnumManager.registerEnum(
    "CurrencyType",
    CurrencyType as unknown as Record<string, number>,
  );
  // DataEnvironment を登録
  EnumManager.registerEnum(
    "DataEnvironment",
    DataEnvironment as unknown as Record<string, number>,
  );
  // ExpireType を登録
  EnumManager.registerEnum(
    "ExpireType",
    ExpireType as unknown as Record<string, number>,
  );
  // FollowRequestActionType を登録
  EnumManager.registerEnum(
    "FollowRequestActionType",
    FollowRequestActionType as unknown as Record<string, number>,
  );
  // GiftDistributionType を登録
  EnumManager.registerEnum(
    "GiftDistributionType",
    GiftDistributionType as unknown as Record<string, number>,
  );
  // GiftState を登録
  EnumManager.registerEnum(
    "GiftState",
    GiftState as unknown as Record<string, number>,
  );
  // ItemReasonType を登録
  EnumManager.registerEnum(
    "ItemReasonType",
    ItemReasonType as unknown as Record<string, number>,
  );
  // ItemType を登録
  EnumManager.registerEnum(
    "ItemType",
    ItemType as unknown as Record<string, number>,
  );
  // LobbySlotState を登録
  EnumManager.registerEnum(
    "LobbySlotState",
    LobbySlotState as unknown as Record<string, number>,
  );
  // LobbyState を登録
  EnumManager.registerEnum(
    "LobbyState",
    LobbyState as unknown as Record<string, number>,
  );
  // LobbyStreamAction を登録
  EnumManager.registerEnum(
    "LobbyStreamAction",
    LobbyStreamAction as unknown as Record<string, number>,
  );
  // LobbyStreamEvent を登録
  EnumManager.registerEnum(
    "LobbyStreamEvent",
    LobbyStreamEvent as unknown as Record<string, number>,
  );
  // LobbyStreamResultType を登録
  EnumManager.registerEnum(
    "LobbyStreamResultType",
    LobbyStreamResultType as unknown as Record<string, number>,
  );
  // LogicOperator を登録
  EnumManager.registerEnum(
    "LogicOperator",
    LogicOperator as unknown as Record<string, number>,
  );
  // MaintenanceType を登録
  EnumManager.registerEnum(
    "MaintenanceType",
    MaintenanceType as unknown as Record<string, number>,
  );
  // MatchType を登録
  EnumManager.registerEnum(
    "MatchType",
    MatchType as unknown as Record<string, number>,
  );
  // MissionTaskType を登録
  EnumManager.registerEnum(
    "MissionTaskType",
    MissionTaskType as unknown as Record<string, number>,
  );
  // MissionType を登録
  EnumManager.registerEnum(
    "MissionType",
    MissionType as unknown as Record<string, number>,
  );
  // NotificationStreamAction を登録
  EnumManager.registerEnum(
    "NotificationStreamAction",
    NotificationStreamAction as unknown as Record<string, number>,
  );
  // NotificationStreamEvent を登録
  EnumManager.registerEnum(
    "NotificationStreamEvent",
    NotificationStreamEvent as unknown as Record<string, number>,
  );
  // NotificationType を登録
  EnumManager.registerEnum(
    "NotificationType",
    NotificationType as unknown as Record<string, number>,
  );
  // OSType を登録
  EnumManager.registerEnum(
    "OSType",
    OSType as unknown as Record<string, number>,
  );
  // OrnamentType を登録
  EnumManager.registerEnum(
    "OrnamentType",
    OrnamentType as unknown as Record<string, number>,
  );
  // PlatformType を登録
  EnumManager.registerEnum(
    "PlatformType",
    PlatformType as unknown as Record<string, number>,
  );
  // PurchaseLimitScopeType を登録
  EnumManager.registerEnum(
    "PurchaseLimitScopeType",
    PurchaseLimitScopeType as unknown as Record<string, number>,
  );
  // ShogiPieceRarityType を登録
  EnumManager.registerEnum(
    "ShogiPieceRarityType",
    ShogiPieceRarityType as unknown as Record<string, number>,
  );
  // SubscriptionIntervalType を登録
  EnumManager.registerEnum(
    "SubscriptionIntervalType",
    SubscriptionIntervalType as unknown as Record<string, number>,
  );
  // SubscriptionType を登録
  EnumManager.registerEnum(
    "SubscriptionType",
    SubscriptionType as unknown as Record<string, number>,
  );
  // UserFollowState を登録
  EnumManager.registerEnum(
    "UserFollowState",
    UserFollowState as unknown as Record<string, number>,
  );
  // UserMigrateBitType を登録
  EnumManager.registerEnum(
    "UserMigrateBitType",
    UserMigrateBitType as unknown as Record<string, number>,
  );
}

/**
 * 利用可能なenum型の一覧
 */
export const AVAILABLE_ENUMS = [
  "ComparisonOperator",
  "ContactType",
  "CurrencyType",
  "DataEnvironment",
  "ExpireType",
  "FollowRequestActionType",
  "GiftDistributionType",
  "GiftState",
  "ItemReasonType",
  "ItemType",
  "LobbySlotState",
  "LobbyState",
  "LobbyStreamAction",
  "LobbyStreamEvent",
  "LobbyStreamResultType",
  "LogicOperator",
  "MaintenanceType",
  "MatchType",
  "MissionTaskType",
  "MissionType",
  "NotificationStreamAction",
  "NotificationStreamEvent",
  "NotificationType",
  "OSType",
  "OrnamentType",
  "PlatformType",
  "PurchaseLimitScopeType",
  "ShogiPieceRarityType",
  "SubscriptionIntervalType",
  "SubscriptionType",
  "UserFollowState",
  "UserMigrateBitType",
] as const;

/**
 * Enum型の型定義
 */
export type AvailableEnumType = (typeof AVAILABLE_ENUMS)[number];

// 自動登録を実行
registerAllEnums();
